/**
 *
 * Organizations/Show/Appointments/Table
 *
 */

import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import ReactTable, { dateTimeCell, dateAccessor } from 'components/ReactTable'

function AppointmentsTable({ appointments, is_subcomponent, ...props }) {
	const columns = [
		{
			Header: 'Appointment',
			accessor: (a) => a.attendee_record?.contact?.full_name,
			Cell: ({ row: { original: a }, value }) => (
				<div style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
					<Link to={`/appointments/${a.id}`} className="table-link">
						{value}
					</Link>
				</div>
			),
			disableFilterBy: is_subcomponent,
			width: 220,
		},
		{
			Header: 'Advisor',
			id: 'advisor',
			accessor: (a) => a.user.full_name,
			show: !is_subcomponent,
		},
		{
			Header: 'Campaign Topic',
			id: 'topic',
			accessor: (e) => e.campaign?.topic_name,
			show: !is_subcomponent,
		},
		{
			Header: 'Start time',
			id: 'start_time',
			accessor: dateAccessor('start_time'),
			Cell: dateTimeCell,
			sortType: 'datetime',
			disableFilterBy: is_subcomponent,
		},
		{
			Header: 'Confirmed',
			accessor: (a) => a.attendee_record?.confirmation_status === 'Confirmed',
			width: 90,
			disableFilterBy: true,
			Cell: ({ value }) => (value ? 'Yes' : 'No'),
		},
	]

	return <ReactTable data={appointments} columns={columns} {...props} />
}

AppointmentsTable.propTypes = {}

export default memo(AppointmentsTable)
